import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItemSettingPricing } from '../editor-booking-item-setting/editor-booking-item-setting-pricing.model';
import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-booking-item-setting-value-pricing',
    templateUrl: './editor-booking-item-setting-value.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorBookingItemSettingValuePricingComponent implements OnChanges, OnInit, OnDestroy {
  @Input() itemSetting: EditorBookingItemSettingPricing;

  private destroyed$ = new Subject<void>();

  currencyNames: { id: string, name: string }[];
  paymentMethodNames: { id: string, name: string }[];

  value: string;

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    combineLatest(this.editorData.currencyNames$, this.editorData.paymentMethodNames$)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(([currencyNames, paymentMethodNames]) => {
        this.currencyNames = currencyNames;
        this.paymentMethodNames = paymentMethodNames;
        this.value = this.getValue();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSetting) {
      this.value = this.getValue();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getValue(): string {
    if (this.currencyNames === undefined || this.paymentMethodNames === undefined) {
      return $localize `Not available`;
    }

    let value = '';

    if (this.itemSetting.price !== null) {
      value = `${this.itemSetting.price} ${this.itemSetting.getCurrencyName(this.currencyNames)}`;
    }

    if (this.itemSetting.methods.length > 0) {
      value = $localize `${value}, paid via ${this.itemSetting.getMethodsAsString(this.paymentMethodNames)}`;
    }

    return value;
  }
}
